import React from 'react';

import { PlaidEmbeddedSearch } from 'src/payments/components';
import { CompleteAccount } from 'src/payments/dutchie-pay/signup/views/complete-account';
import { Loading, TermsView } from 'src/payments/dutchie-pay/signup/views';
import { LoadingSkeleton } from 'src/components/core';
import { EnrollmentSteps, connectingBankSteps, tosSteps } from 'src/payments/constants';
import { useInstoreEnrollment } from 'src/hooks/use-instore-enrollment';
import { InstoreEnrollmentStatus } from 'src/state/instore-enrollment';
import { useConnectBank } from './use-connect-bank';
import { SkipButton, StepHeader, StepPanel, StepFooter } from '../shared-components';

export function ConnectBank(): JSX.Element {
  const { currentStep, isPlaidLoading, onLoadingStateChange, handleOnError, handleOnLinkExit } = useConnectBank();
  const instoreEnrollment = useInstoreEnrollment();

  const handleSkip = (): void => {
    instoreEnrollment.setDeclinedPayByBank(true);
    instoreEnrollment.setCurrentStatus(InstoreEnrollmentStatus.finishedEnrollment);
  };

  return (
    <>
      <StepHeader
        title='Link your bank for faster checkouts'
        stepDescription="You'll only be charged after you place an order."
        data-testid='connect-bank'
      />

      <StepPanel>
        {currentStep === EnrollmentSteps.connectBank && (
          <PlaidEmbeddedSearch
            height={450}
            onLoadingStateChange={onLoadingStateChange}
            handleOnError={handleOnError}
            handleOnLinkExit={handleOnLinkExit}
          />
        )}
        {isPlaidLoading && <LoadingSkeleton height={450} width={300} data-testid='plaid-loading-skeleton' />}
        {currentStep === EnrollmentSteps.completeAccount && <CompleteAccount />}
        {currentStep === EnrollmentSteps.bankAccountsLoading && <Loading steps={connectingBankSteps} />}
        {currentStep === EnrollmentSteps.tosLoading && <Loading steps={tosSteps} />}
        {currentStep === EnrollmentSteps.terms && <TermsView continueTextOverride='Continue' />}
      </StepPanel>
      <StepFooter>
        <SkipButton onClick={handleSkip}>Skip for now</SkipButton>
      </StepFooter>
    </>
  );
}
